import axios from '../shared/axios';
// import qs from 'querystring';
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as actionsDuck from "../store/ducks/actions.duck";


export function createSubscription(payload) {
    return axios.post(`/api/ActionMailSubscription/CreateSubscription`,payload);
}
export function updateSubscription(payload) {
    return axios.post(`/api/ActionMailSubscription/UpdateSubscription`,payload);
}
export function cancelSubscription() {
    return axios.post(`/api/ActionMailSubscription/CancelSubscription`);
}
export function getActiveSubscription() {
    return axios.get(`/api/ActionMailSubscription/GetActiveSubscription`,);
}